import { Skeleton } from "@mantine/core";
import EventCardSkeleton from "./EventCardSkeleton";

/**
 * Full-page skeleton for the ticket booking view:
 * event card + ticket rows.
 */
export default function EventPageSkeleton() {
  return (
    <div className="max-w-md w-full flex flex-col bg-white">
      {/* App bar placeholder */}
      <div className="flex items-center gap-3 p-4">
        <Skeleton height={20} width={20} circle />
        <Skeleton height={20} width="30%" radius="sm" />
      </div>

      <EventCardSkeleton />

      {/* Ticket rows */}
      <div className="flex flex-col gap-3 p-4">
        <Skeleton height={18} width="40%" radius="sm" />
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="flex items-center justify-between border-2 border-gray-200 rounded-xl p-4"
          >
            <div className="flex flex-col gap-2 flex-1">
              <Skeleton height={16} width="60%" radius="sm" />
              <Skeleton height={14} width="30%" radius="sm" />
            </div>
            <Skeleton height={36} width={100} radius="md" />
          </div>
        ))}
      </div>
    </div>
  );
}
